export const BDAP_AMOUNTS = [500, 1000, 1500, 2000, 5000, 10000] as const;

export type BdapAmount = (typeof BDAP_AMOUNTS)[number];

export const BDAP_RECHARGE_LIMITS_BY_AMOUNT: Record<BdapAmount, number[]> = {
  500: [250],
  1000: [250, 500],
  1500: [250, 500, 1500],
  2000: [250, 500, 1500, 2000],
  5000: [250, 500, 1500, 2000, 2500, 3000, 4000],
  10000: [250, 500, 1500, 2000, 2500, 3000, 4000, 5000, 6000, 7000, 8000, 9000],
};

export function isBdapAmount(value: number): value is BdapAmount {
  return (BDAP_AMOUNTS as readonly number[]).includes(value);
}

export function rechargeLimitsForAmount(amount: number): number[] {
  if (!isBdapAmount(amount)) {
    return [];
  }
  return BDAP_RECHARGE_LIMITS_BY_AMOUNT[amount];
}

export function formatBdapDollars(value: number | null | undefined): string {
  if (value == null || Number.isNaN(Number(value))) {
    return "—";
  }
  return `$${Number(value).toLocaleString("en-US")}`;
}

export function isGuildMortgageEmail(email?: string | null): boolean {
  return (email ?? "").toLowerCase().includes("@guildmortgage.net");
}
